import { render } from "./crawler.vue?vue&type=template&id=ea478206"
import script from "./crawler.vue?vue&type=script&lang=js"
export * from "./crawler.vue?vue&type=script&lang=js"

import exportComponent from "/Users/karenmeliksetian/work_projects/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/vue/crawler.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ea478206"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ea478206', __exports__)) {
    console.log('reload')
    api.reload('ea478206', __exports__)
  }
  
  module.hot.accept("./crawler.vue?vue&type=template&id=ea478206", () => {
    console.log('re-render')
    api.rerender('ea478206', render)
  })

}


export default __exports__